import mixin from '../../mixins/Mixin.js';
var event = document.createEvent('Event');

// Define that the event name is 'build'.
event.initEvent('callFullScreenMethode', true, true);
export default (editor, config = {}) => {
  const domc = editor.DomComponents;
  const defaultType = domc.getType('default');
  const defaultModel = defaultType.model;
  const defaultView = defaultType.view;
  var modal = null;
  var self;

  var players = [];
  var page = 0;
  var totalNumber = 1;
  var initialise = false;
  var dbl = false;
  domc.addType('video_mp4', {
    model: defaultModel.extend(
      {
        defaults: Object.assign({}, defaultModel.prototype.defaults, {
          'custom-name': 'video_mp4',
          tagName: 'video',
          src: '',
          width: '100%',
          height: '100%',
          traits: [
            {
              type: 'text',
              label: 'src',
              name: 'src',
              changeProp: 1,
            },
            {
              type: 'checkbox',
              label: 'autoplay',
              name: 'autoplay',
              changeProp: 0,
            },
            {
              type: 'checkbox',
              label: 'loop',
              name: 'loop',
              changeProp: 0,
            },
            {
              type: 'checkbox',
              label: 'controls',
              name: 'controls',
              changeProp: 0,
            },
          ],
        }),
        init() {
          this.listenTo(this, 'change:src', this.updateSrc);
          this.listenTo(this, 'change:autoplay', this.updateAttrAutoplay);
          this.listenTo(this, 'change:loop', this.updateAttrLoop);
          this.listenTo(this, 'change:controls', this.updateAttrControls);
        },
        toHTML() {
          return this.view && this.view.el.getAttribute('data-gjs-type') === 'video_mp4'
            ? this.view.el.outerHTML
            : '';
        },
        updateSrc() {
          const src = this.view.el.getAttribute('src') || this.view.getIframe().src;
          if (src.indexOf(this.get('src')) === -1 && !dbl) {
            this.updateAttrAutoplay();
            this.updateAttrLoop();
            this.updateAttrControls();
          }
        },

        updateAttrAutoplay() {
          let playerIframe = this.view.el;
          playerIframe.setAttribute('autoplay', this.get('autoplay'));
          this.set('autoplay', this.get('autoplay'));
          this.view.getIframe().autoplay = 'autoplay';
          playerIframe.setAttribute('data-autoplay', this.get('autoplay'));
          this.set('data-autoplay', this.get('autoplay'));
          this.view.getIframe()['data-autoplay'] = 'autoplay';
        },
        updateAttrLoop() {
          let playerIframe = this.view.el;
          playerIframe.setAttribute('loop', this.get('loop'));
          this.set('loop', this.get('loop'));
          this.view.getIframe().loop = 'loop';
        },
        updateAttrControls() {
          let playerIframe = this.view.el;
          playerIframe.setAttribute('controls', this.get('controls'));
          this.set('controls', this.get('controls'));
          this.view.getIframe().controls = 'controls';
        },
        isComponent(el) {
          var result = '';
          if (el.tagName === 'div') {
            result = { type: 'video_mp4', src: el.src };
          }
          return result;
        },
      },
      {
        isComponent(el) {
          var result = '';
          if (el.tagName === 'div') {
            result = { type: 'video_mp4', src: el.src };
          }
          return result;
        },
      },
    ),
    view: defaultView.extend({
      events: {
        click: 'updateSrcField',
        dblclick: 'openModal',
      },
      initialize(o) {
        defaultView.prototype.initialize.apply(this, arguments);
        self = this;
        this.model.listenTo(this.model, 'active', self.insertIframe);
        modal = editor.Modal;
        modal.setTitle(config.translate);
      },
      getIframe() {
        if (!this.iframe) {
          var ifrm = document.createElement('video');
          ifrm.className = this.ppfx + 'no-pointer';
          ifrm.src = this.model.get('src');
          ifrm.id = 'video_mp4-' + mixin.methods.makeId();
          ifrm.width = this.model.get('width');
          ifrm.height = this.model.get('height');
          ifrm.style = 'border:none;overflow:hidden;height:100%;width:100%';
          ifrm.scrolling = 'no';
          ifrm.frameborder = '0';
          ifrm.allowtransparency = 'true';
          ifrm.allow = 'encrypted-media';

          this.iframe = ifrm;
        }
        return this.iframe;
      },
      insertIframe() {
        //self.el.appendChild(self.getIframe());
        document.getElementById('CanvOverlay').style.display = 'block';

        self.openModal();
      },
      noVideos() {
        modal.setContent(`<div id="modal-players-mp4-list" class="container" style=" min-height: 100px;padding:5px;display: inline-block;max-height: 660px; overflow-y: auto">
                                        <span><img src="
                    static/images/nofound.png" alt="nofound image"></span>
                                   </div>`);
      },
      reloadPlayersMP4List() {
        var titleVideo = document.getElementById('myInput');
        var noVideo = document.getElementById('noVideo');
        if (noVideo != null) {
          noVideo.style.display = 'none';
        }

        page = page + 1;
        var modalContent = document.getElementById('modal-players-mp4-list');
        if (titleVideo.value !== '') {
          page = 1;
        }
        self.showLoader();
        config
          .http(window.ApiToken)
          .get(
            config.routing.generate(config.api_routing, {
              id: '',
              page: page,
              nbParPage: 20,
              client: config.client.paramsClient.client,
              searchWord: titleVideo.value,
              maxBitrate: true,
            }),
          )
          .then(
            function(response) {
              self.hideLoader();
              if (response.data.code === 200) {
                var selected = 0;
                totalNumber = response.data.nombre_total;
                document.querySelector('.gjs-mdl-dialog.gjs-one-bg.gjs-two-color').style.display =
                  'block';

                if (response.data.medias.length === 0 && players.length === 0) {
                  self.noVideos();
                } else if (response.data.medias.length === 0 && titleVideo.value !== '') {
                  modalContent.innerHTML = '';
                  var element = document.createElement('div');
                  element.className = 'no-found-video';
                  element.id = 'noVideo';
                  element.innerHTML =
                    `<img src="` +
                    'static/images/nofound.png' +
                    `" alt="nofound image">
                         `;
                  modalContent.appendChild(element);
                } else {
                  if (titleVideo.value !== '') {
                    modalContent.innerHTML = '';
                  }
                  response.data.medias.forEach(val => {
                    var element = document.createElement('div');
                    element.setAttribute('data-duration', val.duration);
                    element.id = 'mp4i' + val.id;
                    element.className = 'player-mp4-item';
                    var srcImage;
                    if (val.logo && val.logo !== '') {
                      srcImage = val.logo;
                    } else {
                      srcImage = '/display/static/images/vignette.jpg';
                    }
                    element.innerHTML =
                      `<img src="` +
                      srcImage +
                      `" alt="Card image">
                          <div class="vidPlayerMP4 vid-position">
                               <h5 class="descriptionPlayerMP4 desc-position" title="` +
                      val.title +
                      `">` +
                      val.title +
                      `</h5>
                                </div><div :title="` +
                      val.duration +
                      `" class=" durationPlayerMP4 duration-style">` +
                      mixin.methods.getDuration(val.duration) +
                      `</div>  <img
                  src="/display/static/images/tick.svg"
                  class="tick-img-player-mp4"
                  style=" display: none;"
             
                />`;
                    modalContent.appendChild(element);
                  });

                  response.data.medias.forEach(val => {
                    const el = document.getElementById('mp4i' + val.id);

                    el.addEventListener('click', function() {
                      if (selected !== 0) {
                        document.getElementById('mp4i' + selected).classList.remove('selected');
                      }

                      selected = val.id;
                      document.getElementById('mp4i' + val.id).classList.add('selected');

                      // Problème 12 : on retient l'image de la médiathèque comme
                      // `poster`. Sans elle, un écran vidéo n'a aucune image à
                      // afficher — ni pour la vignette (dom-to-image ne sait pas
                      // rasteriser un <video>), ni avant le démarrage de la lecture.
                      var poster = val.logo && val.logo !== '' ? val.logo : '';

                      var selectedElement = grapesjsEMP.editors[0].getSelected();
                      if (selectedElement !== undefined) {
                        try {
                          grapesjsEMP.editors[0]
                            .getSelected()
                            .view.el.querySelector('video')
                            .setAttribute('src', val.lienMp4);
                        } catch (e) {}
                        selectedElement.set('duration', val.duration);
                        self.getIframe().src = val.lienMp4;
                        selectedElement.set('src', val.lienMp4);
                        self.getIframe().setAttribute('duration', val.duration);
                        if (poster) {
                          selectedElement.addAttributes({ poster: poster });
                          self.getIframe().setAttribute('poster', poster);
                        }
                      } else {
                        self.getIframe().src = val.lienMp4;
                        self.model.set('src', val.lienMp4);
                        self.getIframe().setAttribute('duration', val.duration);
                        self.model.set('duration', val.duration);
                        if (poster) {
                          self.model.addAttributes({ poster: poster });
                          self.getIframe().setAttribute('poster', poster);
                        }
                      }
                      if (poster) {
                        try {
                          self.model.view.el.setAttribute('poster', poster);
                        } catch (e) {}
                      }
                      /*to do full screen default */
                      /*to do full screen default */
                      event.myDuration = val.duration;
                      document.dispatchEvent(event);
                      self.model.view.el.pause();
                      self.model.view.el.controls = false;
                      // self.model.updateUrlVid();
                      //  self.model.updateAttrVid();
                    });
                    el.addEventListener('dblclick', function(e) {
                      document.querySelector('.gjs-mdl-btn-close').click();
                      dbl = true;
                    });
                    el.addEventListener('click', function(e) {
                      dbl = true;
                    });
                  });

                  players = players.concat(response.data.medias);
                  if (players.length === totalNumber) {
                    document
                      .getElementById('modal-players-mp4-container')
                      .removeEventListener('scroll', function() {
                        var listElm = document.getElementById('modal-players-mp4-container');
                        if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
                          self.reloadPlayersMP4List();
                        }
                      });
                    self.hideLoader();
                  } else {
                    if (!initialise) {
                      document
                        .getElementById('modal-players-mp4-container')
                        .addEventListener('scroll', function() {
                          var listElm = document.getElementById('modal-players-mp4-container');
                          if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
                            self.reloadPlayersMP4List();
                          }
                        });
                      initialise = true;
                    }
                  }
                }
              }
            },
            function(response) {
              self.hideLoader();
            },
          );
      },

      hideLoader() {
        document.getElementById('loader-list').style.visibility = 'hidden';
      },
      showLoader() {
        document.getElementById('loader-list').style.visibility = 'visible';
      },
      onScroll() {
        var listElm = document.getElementById('modal-players-mp4-container');
        //var titleVideo = document.getElementById('myInput');

        if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
          self.reloadPlayersMP4List();
        }
      },
      openModal() {
        page = 0;
        players = [];
        initialise = false;
        modal.setContent(`<div id="modal-players-mp4-container" class="players-mp4-list">
                            <div id="search-list" class="search-wrapper">
                                      <input type="text" id="myInput"  placeholder="Chercher une video.."  />
                                    </div>
                                       <div id="modal-players-mp4-list" class="players-mp4-wrapper"></div>
                                       <div id="loader-list" class="loader-4 center"><span></span></div>
                                   </div>`);

        var titleVideo = document.getElementById('myInput');
        var configMixin = mixin.methods.getLangCode('display-player-plugin');
        if (titleVideo) titleVideo.placeholder = configMixin.translate.placeholder;
        self.reloadPlayersMP4List();
        modal.open();
        modal.getModel().once('change:open', function() {
          document.getElementById('CanvOverlay').style.display = 'none';

          const getAllComponents = (model, result = []) => {
            result.push(model);
            model.components().each(mod => getAllComponents(mod, result));
            return result;
          };
          const all = getAllComponents(editor.DomComponents.getWrapper());

          for (var i = 0; i < all.length; i++) {
            let type = all[i].attributes.type;
            let src = all[i].attributes.src;
            if (type === 'video_mp4' || type === 'playlist' || type === 'live') {
              if (!src) {
                grapesjsEMP.editors[0].UndoManager.undo();
              }
            }
          }
        });

        var textInput = document.getElementById('myInput');
        textInput.addEventListener('input', self.reloadPlayersMP4List);
      },
      updateSrcField() {
        const src = this.model.get('src') || this.el.getAttribute('src') || this.getIframe().src;
        const duration =
          this.model.get('duration') ||
          this.el.getAttribute('duration') ||
          this.getIframe().getAttribute('duration');
        this.model.set('src', src);
        this.model.set('duration', duration);
      },
      render(...args) {
        defaultView.prototype.render.apply(this, args);
        if (this.model.get('src')) {
          // this.el.appendChild(this.getIframe());
        }
        this.updateClasses();
        this.updateAttributes();
        return this;
      },
    }),
  });
};



// WEBPACK FOOTER //
// ./src/plugins/player-mp4/components.js